<template>
  <div class="pdf-container">
    <canvas v-for="cun in pageNum" :key="cun" class="pdf-canvas" :id="`the-canvas-${cun}`"></canvas>
  </div>
</template>

<script>
import PDFJS from 'pdfjs-dist';

export default {
  name: 'pdf-view',
  data() {
    return {
      pdfDoc: null,
      pageNum: 1,
      scale: 1,
    };
  },
  methods: {
    showPDF(url) {
      const that = this;
      PDFJS.getDocument(url).then((pdf) => {
        that.pdfDoc = pdf;
        that.pageNum = pdf.numPages;
        that.$nextTick(() => {
          // eslint-disable-next-line no-plusplus
          for (let i = 1; i <= that.pageNum; i++) {
            that.renderPage(i);
          }
        });
      });
    },
    renderPage(num) {
      const that = this;
      this.pdfDoc.getPage(num).then((page) => {
        const viewport = page.getViewport(that.scale);
        const canvas = document.getElementById(`the-canvas-${num}`);
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const renderContext = {
          canvasContext: canvas.getContext('2d'),
          viewport,
        };
        page.render(renderContext);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .pdf-container {
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: auto;
    .pdf-canvas {
      width: 100%;
      height: 100%;
    }
  }
</style>
